var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        "custom-marker " +
        (_vm.value.selected ? "selected" : "") +
        "  " +
        (this.isHover ? "hover" : "")
    },
    [
      _c("div", { staticClass: "content-area" }, [
        !_vm.value.selected
          ? _c(
              "h4",
              {
                staticClass: "nowrap more currency",
                staticStyle: { color: "black" }
              },
              [_vm._v("+ " + _vm._s(_vm.value.price) + " €")]
            )
          : _c(
              "h6",
              {
                staticClass: "currency mb-0 nowrap",
                staticStyle: { cursor: "pointer!important" }
              },
              [_vm._v(_vm._s(_vm.value.name.substring(0, 30)) + "...")]
            )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "square" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05a837c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a837c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/google-map/CustomServiceMarker.vue
// module id = null
// module chunks = 